import { createAction } from 'redux-actions';
import message from '@itt/frontend-scaffold-components/dist/Message/Message';
import { editUserBasicInfo, getUserBasicInfo } from '../../common/service/user';
import STATUS_CODE from '../../../request/statusCode';
import { RESET, SET_BASIC_INFO, SET_LOADING } from './actionTypes';
import { INITIAL_BASIC_INFO } from './consts';

const reset = createAction(RESET);

const setBasicInfo = createAction(SET_BASIC_INFO);

const setLoading = createAction(SET_LOADING);

const getBasicInfo = ({ userName }) => {
  return dispatch => {
    dispatch(setLoading(true));
    return getUserBasicInfo({ userName }).then(res => {
      dispatch(setLoading(false));
      if (res.statusCode === STATUS_CODE.OK) {
        const {
          name,
          displayName,
          telephone,
          email,
          company,
          projects,
          status,
          isLocked,
          passwordStatus,
          contractNumber,
          adName,
          wiwName
        } = res.data;
        return dispatch(
          setBasicInfo({
            name,
            displayName,
            telephone,
            email,
            company,
            projects,
            status,
            isLocked,
            passwordStatus,
            contractNumber,
            adName,
            wiwName
          })
        );
      }
      return dispatch(setBasicInfo(INITIAL_BASIC_INFO));
    });
  };
};

const editBasicInfo = ({
  name,
  displayName,
  telephone,
  email,
  company,
  contractNumber
}) => {
  return dispatch => {
    return editUserBasicInfo({
      name,
      displayName,
      telephone,
      email,
      company,
      contractNumber
    }).then(res => {
      if (res.statusCode === STATUS_CODE.OK) {
        message.success('User edited successfully !');
        dispatch(getBasicInfo({ userName: name }));
        return true;
      }
      return false;
    });
  };
};

export { getBasicInfo, setBasicInfo, reset, editBasicInfo, setLoading };
